import * as Yup from 'yup';
import * as moment from 'moment';

export function getInitialValues(uploadType, selectedItem) {
    if (uploadType === 'reUpload') {
        let deliveryDate, deliveryTime
        if (selectedItem) {
            let deliveryDateTemp
            if (selectedItem.userType === 'BUYER') deliveryDateTemp = selectedItem.buyerDeliveryDate
            else deliveryDateTemp = selectedItem.sellerDeliveryDate
            deliveryDate = moment(deliveryDateTemp).format("MM/DD/YYYY hh:mm a")
            let ampm = deliveryDate.substring(deliveryDate.length - 2, deliveryDate.length)
            deliveryTime = deliveryDate.substring(deliveryDate.length - 8, deliveryDate.length - 3)
            if (ampm === "pm") {
                let deliveryTimeHour = String(parseInt(deliveryTime.substring(0, 2)) + 12)
                deliveryTime = deliveryTimeHour + deliveryTime.substring(2, 5)
            }
        }
        return {
            bolDocument: '',
            orderDeliveryDate: deliveryDate,
            orderDeliveryTime: deliveryTime
        }
    } else {
        let deliveryDate, deliveryTime
        deliveryDate = moment(new Date()).format("YYYY-MM-DD")
        let hours = new Date().getHours()
        let mins = new Date().getMinutes()
        if (hours < 10) hours = "0" + hours
        if (mins < 10) mins = "0" + mins
        deliveryTime = hours + ':' + mins
        return {
            bolDocument: '',
            orderDeliveryDate: deliveryDate,
            orderDeliveryTime: deliveryTime
        }
    }
}

export function getRegisterSchema(uploadType) {
    if (uploadType === "reUpload") {
        let schemaAttributes = {
            bolDocument: Yup.string().required(''),
        };
        return Yup.object().shape(schemaAttributes);
    } else {
        let schemaAttributes = {
            bolDocument: Yup.string().required(),
        };
        return Yup.object().shape(schemaAttributes);
    }
}
